/* Reopen the native contact form after Shopify returns success or errors. */
(() => {
  function revealReturnedForm(root = document) {
    const result = root.querySelector('[data-footer-form-result]');
    const dialog = result?.closest('dialog');
    if (!dialog) return;
    if (!dialog.open) dialog.showModal();
    result.focus();
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => revealReturnedForm(), { once: true });
  } else {
    revealReturnedForm();
  }
  document.addEventListener('shopify:section:load', event => revealReturnedForm(event.target));
})();
